import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const AlphaLogout: React.FC = () => {
  const history = useHistory();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    localStorage.removeItem('authToken');
    window.dispatchEvent(new Event('authChange'));
  }, []);

  useEffect(() => {
    if (countdown <= 0) {
      history.push('/');
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown, history]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-step">
          <div className="step-header">
            <h2>Logged Out</h2>
            <p>You have been successfully logged out.</p>
            <p>Redirecting to home in {countdown} seconds...</p>
          </div>
        </div>
      </div>
    </div>
  );
};
